import { RouteRecordRaw } from 'vue-router'

const HomeRouter: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/Index.vue')
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('@/views/home/Success.vue')
  }
]
export default HomeRouter
